import React, { useEffect, useState } from "react"

import PropTypes, { element } from "prop-types"

import "./index.less"
import {
  Drawer,
  Input,
  Select,
  Button,
  Popover,
  Radio,
  Space,
  Table,
  Tooltip,
  message,
} from "antd"
import Loader from "../../../../components/Loader"
import CancelDrawerModal from "../CancelDrawerModal"
import { buttonAction_btn } from "../../../../components/Snowplow/config"
import { DrawerSegmentImportableResult } from "./DrawerSegmentImportableResult"
import { DrawerSegmentImportableUpload } from "./DrawerSegmentImportableUpload"
import { CircleDeleteIcon } from "../../../../icons/svg/iconCircleDelete"
import {
  CloseCircleOutlined,
  SearchOutlined,
  MinusCircleFilled,
} from "@ant-design/icons"
import { buttonAction_btns } from "../../../../components/Snowplow/config2"

const { TextArea } = Input

export const DrawerSegment = (props) => {
  const [currentStep, setCurrentStep] = useState(0)
  const [rowCollaboratorSelected, setRowCollaboratorSelected] = useState([])
  const [selectedVariable, setSelectedVariable] = useState(3)
  const [segmentName, setSegmentName] = useState("")
  const [segmentDescription, setSegmentDescription] = useState("")
  const [selectedGroups, setSelectedGroups] = useState([])
  const [showCancelDrawerModal, setShowCancelDrawerModal] = useState(false)
  const [radioColaboratorMode, setRadioColaboratorMode] = useState("manual")
  const [tablegroups, setTablegroups] = useState([])
  const [tableGroupsInputSearch, setTableGroupsInputSearch] = useState("")
  const importColaboratorsMode = [
    { label: "Selección manual", value: "manual" },
    { label: "Importación", value: "import" },
  ]
  const columns = [
    {
      title: "Colaborador",
      dataIndex: "name",
      render: (text, record) => {
        return (
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}>
            <span className={{ maxWidth: "375px" }}>{text}</span>
            <Tooltip title="Eliminar" placement="left">
              <span
                className="collaborator-table-remove"
                aria-label={`collaborator-table-remove-${record.id_group}`}
                style={{ width: "50px" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={() => {
                    removeSelectedGroupsByGroupIdArray([record.id_group])
                  }}>
                  <MinusCircleFilled
                    style={{
                      color: "#E37879",
                      cursor: "pointer",
                    }}
                  />
                </div>
              </span>
            </Tooltip>
          </div>
        )
      },
    },
  ]
  useEffect(() => {
    refreshTableGroups()
  }, [selectedGroups, props.groups])
  const refreshTableGroups = () => {
    let array = props.groups?.filter((group) => {
      return selectedGroups?.includes(group.id_group)
    })
    array = array.map((group) => {
      return { ...group, key: group.id_group }
    })
    array.sort((a, b) => {
      if (a.last_name) {
        return a.last_name
          .toLowerCase()
          .localeCompare(b.last_name.toLowerCase())
      }
      return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
    })
    setTablegroups(array)
  }
  useEffect(() => {
    props.getGroupsWatcher(selectedVariable)
  }, [selectedVariable])

  useEffect(() => {
    if (props.mode === "edit" && props.selectedSegment) {
      if (props.selectedSegment.groups) {
        const segmentGroups = props.selectedSegment.groups.map((group) => {
          return group.id_group
        })
        setSegmentName(props.selectedSegment.name_segment)
        setSegmentDescription(
          props.selectedSegment.description_segment
            ? props.selectedSegment.description_segment
            : ""
        )
        setSelectedVariable(props.selectedSegment.id_segment_variable)
        setSelectedGroups(segmentGroups)
      }
    }
  }, [props.selectedSegment])

  useEffect(() => {
    if (props.mode === "create") {
      setSegmentName("")
      setSegmentDescription("")
      setSelectedVariable(3)
      setSelectedGroups([])
    }
  }, [props.mode])

  useEffect(() => {
    if (props.isLoadingCreateSegment === false) {
      if (!props.isErrorCreateSegment) {
        onOkCloseDrawer()
      }
    }
  }, [props.isLoadingCreateSegment])

  const combineGroupResultsWithSuccessfullEmployeeResults = (
    employeeResults
  ) => {
    // concat Array results without duplicates the employee results (retrieve the id_segment) into selectedgroups
    const addedEmployeeResults = employeeResults.map((employeeResult) => {
      return employeeResult.id_employee
    })
    const concatenatedArray = [...selectedGroups, ...addedEmployeeResults]
    // remove duplicates if exists
    const uniqueArray = concatenatedArray.filter((item, index) => {
      return concatenatedArray.indexOf(item) === index
    })
    setSelectedGroups(uniqueArray)
  }

  const onRadioColaboratorModeChange = (e) => {
    setRadioColaboratorMode(e.target.value)
  }
  const removeSelectedGroupsByGroupIdArray = (groupIdArray) => {
    const newSelectedGroups = selectedGroups.filter(
      (group) => !groupIdArray.includes(group)
    )
    const selectedRowKeys = rowCollaboratorSelected.filter((row) =>
      groupIdArray.some((group) => group === row.id_employee)
    )
    if (groupIdArray.length > 1) {
      message.success(`Colaboradores eliminados`, 5)
    } else {
      message.success(`Colaborador eliminado`, 5)
    }
    setRowCollaboratorSelected(selectedRowKeys)
    setSelectedGroups(newSelectedGroups)
  }

  const renderVariablesOptions = () => {
    let objects = []
    props.variables.forEach((variable) => {
      objects.push(
        <Select.Option value={variable.id_segment_variable}>
          {variable.name}
        </Select.Option>
      )
    })
    return objects
  }

  const validateFields = () => {
    return (
      selectedGroups.length > 0 &&
      segmentName.trim().length &&
      selectedVariable > 0
    )
  }

  const validateUpdateFields = () => {
    const helperDescription = props.selectedSegment.description_segment
      ? props.selectedSegment.description_segment
      : ""
    let segmentGroups = []
    if (props.selectedSegment.groups) {
      segmentGroups = props.selectedSegment.groups.map((group) => {
        return group.id_group
      })
    }
    const checkGroups =
      JSON.stringify(selectedGroups.sort()) ===
      JSON.stringify(segmentGroups.sort())
    return (
      segmentName !== props.selectedSegment.name_segment ||
      segmentDescription !== helperDescription ||
      selectedVariable !== props.selectedSegment.id_segment_variable ||
      !checkGroups
    )
  }

  const renderRadioColaboratorMode = () => {
    const modes = []
    importColaboratorsMode.forEach((mode) => {
      modes.push(
        <Radio value={mode.value} key={mode.value}>
          {mode.label}
        </Radio>
      )
    })
    return modes
  }
  const incrementStep = () => {
    setTableGroupsInputSearch("")
    setCurrentStep(currentStep + 1)
  }
  const renderGroupsOptions = () => {
    let objects = []
    props.groups.forEach((grp) => {
      objects.push(
        <Select.Option
          label={grp.name}
          value={grp.id_group}
          key={`group-${grp.id_group}`}>
          {grp.name}
        </Select.Option>
      )
    })
    return objects
  }

  const onVariableChange = (value) => {
    setSelectedVariable(value)
    setSelectedGroups([])
  }

  const onGroupChange = (value) => {
    setSelectedGroups(value)
  }

  const onNameChange = (event) => {
    if (event.target.value.trim().length) {
      setSegmentName(event.target.value)
    } else {
      setSegmentName("")
    }
  }

  const onDescriptionChange = (event) => {
    if (event.target.value.trim().length) {
      setSegmentDescription(event.target.value)
    } else {
      setSegmentDescription("")
    }
  }

  const onCloseDrawer = () => {
    if (props.mode === "edit") {
      if (validateUpdateFields()) {
        setShowCancelDrawerModal(true)
      } else {
        onOkCloseDrawer()
      }
    } else {
      if (selectedGroups.length > 0) {
        setShowCancelDrawerModal(true)
      } else {
        onOkCloseDrawer()
      }
    }
  }

  const onOkCloseDrawer = () => {
    setSegmentName("")
    setSegmentDescription("")
    setSelectedVariable(3)
    setSelectedGroups([])
    setShowCancelDrawerModal(false)
    setCurrentStep(0)
    setRadioColaboratorMode("manual")
    props.clearImportUpload()
    props.closeDrawer()
    setTableGroupsInputSearch("")
  }

  const onCancelCloseDrawer = () => {
    setShowCancelDrawerModal(false)
  }

  const onSaveSegment = (event) => {
    let body = {}

    if (props.mode === "create") {
      buttonAction_btns("Crear Segmentos - Crear")
      body = {
        name: segmentName,
        description: segmentDescription,
        id_segment_variable: selectedVariable,
        groups: selectedGroups,
      }
    } else {
      body = {
        id_segment: props.selectedSegment.id_segment,
        name: segmentName,
        description: segmentDescription,
        id_segment_variable: selectedVariable,
        groups: selectedGroups,
      }
    }
    props.onCreateSaveClick(body)
   
  }

  const renderFooter = () => {
    if (props.mode === "edit" && !validateUpdateFields()) {
      return <></>
    }
    return (
      <div className="footer-drawer">
        <Button style={{ marginRight: 8 }} onClick={onCloseDrawer}>
          {" "}
          Cancelar{" "}
        </Button>
        <Button
          disabled={!validateFields()}
          type="primary"
          loading={props.isLoadingCreateSegment || props.isLoadingUpdateSegment}
          onClick={onSaveSegment}>
          {props.mode === "create" ? "Crear" : "Guardar"}
        </Button>
      </div>
    )
  }

  let tableGroupsFiltered = []
  if (tableGroupsInputSearch !== "") {
    tableGroupsFiltered = tablegroups.filter((item) => {
      return item.name
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .includes(
          tableGroupsInputSearch
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .toLowerCase()
        )
    })
  }

  const renderTable = () => {
    return (
      <>
        <div className="table-container">
          <Table
            rowSelection={{
              selectedRowKeys: rowCollaboratorSelected,
              onChange: (selectedRowKeys) => {
                setRowCollaboratorSelected(selectedRowKeys)
              },
              selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
            }}
            columns={columns}
            dataSource={
              tableGroupsFiltered.length > 0 ? tableGroupsFiltered : tablegroups
            }
            scrollToFirstRowOnChange
            pagination={{
              pageSizeOptions: [10, 25, 50, 100],
              showSizeChanger: true,
              size: "default",
              defaultPageSize: 10,
            }}
            size="small"
            bordered
          />
        </div>
      </>
    )
  }

  return (
    <>
      <Drawer
        title={props.mode === "create" ? "Crear segmento" : "Editar segmento"}
        width={550}
        onClose={onCloseDrawer}
        closable
        placement="right"
        visible={props.showDrawerSegment}
        bodyStyle={{ padding: 0 }}>
        {props.isLoadingVariables ? (
          <Loader />
        ) : currentStep === 0 ? (
          <div className="drawer-segment-container">
            <div className="drawer-segment-container-input-group">
              <span className="drawer-segment-container-label">Nombre*</span>
              <Input
                maxLength={50}
                placeholder="Ejemplo: Administrativo"
                value={segmentName}
                onChange={onNameChange}
              />
            </div>
            <div className="drawer-segment-container-input-group">
              <span className="drawer-segment-container-label">
                Descripción
              </span>
              <TextArea
                rows={3}
                maxLength={200}
                placeholder="Escribe aquí una breve descripción de tu segmento..."
                value={segmentDescription}
                onChange={onDescriptionChange}
              />
            </div>
            <div className="drawer-segment-container-input-group">
              <span className="drawer-segment-container-label">Variable*</span>
              {props.selectedSegment.segment_in_use ? (
                <Popover
                  content={
                    'No es posible editar estos elementos si se encuentran siendo utilizados por una medición “En curso” o “Finalizada".'
                  }>
                  <Select
                    style={{ width: "60%" }}
                    value={selectedVariable}
                    disabled={props.selectedSegment.segment_in_use}
                    onChange={onVariableChange}>
                    {renderVariablesOptions()}
                  </Select>
                </Popover>
              ) : (
                <Select
                  style={{ width: "60%" }}
                  value={selectedVariable}
                  disabled={props.selectedSegment.segment_in_use}
                  onChange={onVariableChange}>
                  {renderVariablesOptions()}
                </Select>
              )}
            </div>
            <div className="drawer-segment-container-input-group">
              <span className="drawer-segment-container-label">
                {selectedVariable === 2 ? "Integrantes*" : "Grupos*"}
              </span>
              {props.isGroupsLoading ? (
                <Loader height="auto" />
              ) : props.selectedSegment.segment_in_use ? (
                <Popover
                  content={
                    'No es posible editar estos elementos si se encuentran siendo utilizados por una medición “En curso” o “Finalizada".'
                  }>
                  <Select
                    disabled={props.selectedSegment.segment_in_use}
                    maxTagCount={29}
                    maxTagTextLength={14}
                    value={selectedGroups}
                    loading={props.isGroupsLoading}
                    placeholder="Seleccionar..."
                    style={{ width: "100%" }}
                    mode="multiple"
                    optionFilterProp="label"
                    onChange={onGroupChange}>
                    {renderGroupsOptions()}
                  </Select>
                </Popover>
              ) : selectedVariable === 2 ? (
                <>
                  <span className="drawer-segment-container-indicator">
                    Selecciona el método para agregar a los integrantes del
                    segmento
                  </span>
                  <Radio.Group
                    onChange={onRadioColaboratorModeChange}
                    value={radioColaboratorMode}>
                    <Space direction="vertical">
                      {renderRadioColaboratorMode()}
                    </Space>
                  </Radio.Group>
                  <br />
                  {radioColaboratorMode === "manual" ? (
                    <>
                      <Select
                        disabled={props.selectedSegment.segment_in_use}
                        maxTagCount={29}
                        maxTagTextLength={14}
                        value={selectedGroups}
                        loading={props.isGroupsLoading}
                        placeholder="Seleccionar integrantes..."
                        style={{ width: "100%" }}
                        mode="multiple"
                        optionFilterProp="label"
                        onChange={onGroupChange}>
                        {renderGroupsOptions()}
                      </Select>
                    </>
                  ) : (
                    <>
                      <div
                        style={{
                          marginBottom: "12px",
                          display: "flex",
                          justifyContent: "space-between",
                        }}>
                        <Button
                          style={{ width: "max-content", color: "#2694FC" }}
                          onClick={incrementStep}>
                          Importar Colaboradores
                        </Button>

                        {selectedGroups.length > 0 ? (
                          <div style={{ display: "flex", gap: "5px" }}>
                            {rowCollaboratorSelected.length > 0 && (
                              <Button
                                onClick={() => {
                                  removeSelectedGroupsByGroupIdArray(
                                    rowCollaboratorSelected
                                  )
                                }}
                                style={{
                                  width: "max-content",
                                  backgroundColor: "#E37879",
                                  color: "white",
                                }}>
                                Eliminar
                              </Button>
                            )}
                            <Input
                              style={{ width: "150px" }}
                              type="search"
                              value={tableGroupsInputSearch}
                              placeholder="Buscar..."
                              onChange={(e) =>
                                setTableGroupsInputSearch(e.target.value)
                              }
                              suffix={
                                tableGroupsFiltered != "" ? (
                                  <CloseCircleOutlined
                                    style={{
                                      cursor: "pointer",
                                      color: "#FFF",
                                      backgroundColor: "#979797",
                                      borderRadius: "50%",
                                    }}
                                    onClick={() =>
                                      setTableGroupsInputSearch("")
                                    }
                                  />
                                ) : (
                                  <SearchOutlined
                                    style={{
                                      cursor: "pointer",
                                      color: "#A7A3A3",
                                      borderRadius: "50%",
                                    }}
                                  />
                                )
                              }
                            />
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                      {selectedGroups.length > 0 ? renderTable() : <></>}
                      <br />
                    </>
                  )}
                </>
              ) : (
                <Select
                  disabled={props.selectedSegment.segment_in_use}
                  maxTagCount={29}
                  maxTagTextLength={14}
                  value={selectedGroups}
                  loading={props.isGroupsLoading}
                  placeholder="Seleccionar..."
                  style={{ width: "100%" }}
                  mode="multiple"
                  optionFilterProp="label"
                  onChange={onGroupChange}>
                  {renderGroupsOptions()}
                </Select>
              )}
            </div>
            {}
            {renderFooter()}
          </div>
        ) : currentStep === 1 ? (
          <>
            <div className="drawer-segment-container">
              <DrawerSegmentImportableUpload
                mode={props.mode}
                id_segment={props.selectedSegment?.id_segment}
                steps={currentStep}
                changeSteps={setCurrentStep}
                isDownloading={props.isDownloading}
                getTemplateSegmentCollaborators={
                  props.getTemplateSegmentCollaborators
                }
                uploadTemplateSegmentCollaborators={
                  props.uploadTemplateSegmentCollaborators
                }
                importUpload={props.importUpload}
              />
            </div>
          </>
        ) : currentStep === 2 ? (
          <>
            <div className="drawer-segment-container">
              <DrawerSegmentImportableResult
                mode={props.mode}
                id_segment={props.selectedSegment?.id_segment}
                steps={currentStep}
                changeSteps={setCurrentStep}
                getTemplateSegmentCollaborators={
                  props.getTemplateSegmentCollaborators
                }
                uploadTemplateSegmentCollaborators={
                  props.uploadTemplateSegmentCollaborators
                }
                combineGroupResultsWithSuccessfullEmployeeResults={
                  combineGroupResultsWithSuccessfullEmployeeResults
                }
                importUpload={props.importUpload}
                clearImportUpload={props.clearImportUpload}
              />
            </div>
          </>
        ) : (
          <></>
        )}
      </Drawer>
      <CancelDrawerModal
        onOk={onOkCloseDrawer}
        onCancel={onCancelCloseDrawer}
        show={showCancelDrawerModal}
        primaryText={
          props.mode === "create"
            ? "¿Estás seguro de que deseas cancelar la creación?"
            : "¿Estás seguro de que deseas cancelar la edición?"
        }
        secondaryText="La información se perderá y deberás iniciar el proceso nuevamente."
      />
    </>
  )
}

DrawerSegment.propTypes = {
  mode: PropTypes.string,
  showDrawerSegment: PropTypes.bool,
  closeDrawer: PropTypes.func,
  variables: PropTypes.array,
  groups: PropTypes.array,
  onCreateSaveClick: PropTypes.func,
  selectedSegment: PropTypes.object,
}

export default DrawerSegment
